import { Navigate, Route, Routes } from "react-router-dom";

import { Layout } from "./components/Layout";
import { Batches } from "./routes/Batches";
import { Duplicates } from "./routes/Duplicates";
import { PotentialBuyers } from "./routes/PotentialBuyers";
import { ProductDetail } from "./routes/ProductDetail";
import { Products } from "./routes/Products";
import { Review } from "./routes/Review";
import { READONLY } from "./lib/config";

export function App() {
  return (
    <Layout>
      <Routes>
        <Route path="/" element={<Products />} />
        <Route path="/product/:uid" element={<ProductDetail />} />
        {!READONLY && <Route path="/review" element={<Review />} />}
        {!READONLY && <Route path="/duplicates" element={<Duplicates />} />}
        {!READONLY && <Route path="/batches" element={<Batches />} />}
        {!READONLY && <Route path="/buyers" element={<PotentialBuyers />} />}
        {READONLY && <Route path="*" element={<Navigate to="/" replace />} />}
      </Routes>
    </Layout>
  );
}
